<template>
  <el-scrollbar wrap-class="ccui-scrollbar-wrapper">
    <template v-for="item in leftMenu">
      <div :key="'title' + item.subMenuTitle" class="ccui-side-bar-title">
        {{ item.subMenuTitle }}
      </div>
      <el-menu
        :key="item.subMenuTitle"
        :default-active="routeFormat($route.path)"
        :background-color="variables.menuBg"
        :text-color="variables.menuText"
        :active-text-color="variables.menuActiveText"
        mode="vertical"
      >
        <template v-for="route in item.subMenu">
          <sidebar-item
            v-if="route.meta.isShowSideBar"
            :key="route.path"
            :item="route"
            :base-path="route.path"
          />
        </template>
      </el-menu>
    </template>
  </el-scrollbar>
</template>

<script>
import { mapGetters } from "vuex";
import SidebarItem from "./SidebarItem";
import variables from "@/config/styles/variables.scss";

export default {
  components: { SidebarItem },
  props: {
    routeMenu: {
      type: Array,
      default: () => {
        return [];
      }
    },
    // 菜单数据
    leftMenu: {
      type: Array,
      default: () => {
        return [];
      }
    },
    title: {
      type: String,
      default: ""
    }
  },
  computed: {
    ...mapGetters(["permission_routers", "sidebar"]),
    variables() {
      // Sidebar颜色所需变量
      return variables;
    },
    menu() {
      return this;
    },
    menu4() {
      return this.$store.state.app.menu4;
    }
  },
  methods: {
    routeFormat(path) {
      let routeFormat = path
        .split("/")
        .splice(0, 3)
        .join("/");
      const isMenu4 = this.menu4.find(
        v => path.includes(v) && v.includes(routeFormat)
      );
      if (isMenu4) {
        routeFormat = path;
      }

      return routeFormat;
    }
  }
};
</script>
